<div id="sideNav" class="unselectable">
  <button mat-button class="sideNavItem" (click)="navigate('/home')">{{translation.Home}}</button>
  <button mat-button class="sideNavItem" (click)="navigate('/news')">{{translation.WhatsGoingOn}}</button>
  <button mat-button class="sideNavItem" (click)="navigate(module.ForwardLink)" *ngFor="let module of modules">{{module.ModuleName}}</button>
  <div class="breakLineSideNav"></div>
  <button mat-button class="sideNavItem" (click)="passwordChange()">{{translation.PasswordChange}}</button>
  <button mat-button class="sideNavItem" (click)="logout()">{{translation.Logout}}</button>
</div>
